<template>
    <div class="bingo__sheets">
        <slot />
    </div>
</template>

<style lang="scss">
.bingo__sheets {
    display: flex;
    position: relative; // To enable z-index hierarchy
    flex-direction: column;

    @media (min-width: $screen-md) {
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        margin: 35px 0 30px;
    }

    @media (min-width: $screen-lg) {
        margin: 65px;
    }

    @media (min-width: $screen-xl) {
        margin-top: 85px;
    }

    img {
        width: 100%;
        max-width: 302px;
        height: auto;
        margin: 18px auto 0;
        transform: translateX(0);

        @media (min-width: $screen-md) {
            margin: 35px 0 30px;
            transform: translateX(-15px);
        }

        @media (min-width: $screen-lg) {
            width: 412px;
            max-width: none;
            height: 273px;
        }
    }

    div {
        max-width: 510px;

        @media (min-width: $screen-md) {
            font-size: 20px;
        }
    }
}
</style>
